// ─── Fábrica de selectores de equipo de trabajo (acondicionamiento) ──────────
// Cada instancia maneja la búsqueda de operarios, los chips seleccionados y
// los inputs ocultos idUsuariosEquipo[] dentro del formulario que la contiene.
// Se usa en los modales de crear y duplicar orden de trabajo.
window.iniciarSelectorEquipoAcondicionamiento = function (config) {
    const inputFiltro = document.getElementById(config.idFiltro);
    const contResultados = document.getElementById(config.idResultados);
    const contSeleccionados = document.getElementById(config.idSeleccionados);
    const contInputs = document.getElementById(config.idInputs);
    const inputFiltroArea = config.idFiltroArea ? document.getElementById(config.idFiltroArea) : null;

    if (!inputFiltro || !contResultados || !contSeleccionados || !contInputs) return null;

    const requestOptions = {
        method: 'GET',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        redirect: 'follow',
    };

    const v = Date.now();
    let timeoutFiltro = null;
    const operariosSeleccionados = {};

    function escapeHtml(str) {
        str = str === null || str === undefined ? '' : String(str);
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function renderSeleccionados() {
        contInputs.innerHTML = '';
        const ids = Object.keys(operariosSeleccionados);

        if (ids.length === 0) {
            contSeleccionados.innerHTML = '<p class="sinDatos">Aún no has seleccionado operarios.</p>';
            return;
        }

        let htmlChips = '';
        let htmlInputs = '';
        ids.forEach(function (id) {
            const operario = operariosSeleccionados[id];
            htmlChips += `
                <span class="chipOperario" data-id="${id}">
                    <img src="/public/uploads/usuarios/${encodeURIComponent(operario.foto || '')}?v=${v}" alt="operario">
                    ${escapeHtml(operario.nombre)}
                    <button type="button" class="quitarOperarioCrear" data-id="${id}" title="Quitar del equipo">&times;</button>
                </span>
            `;
            htmlInputs += `<input type="hidden" name="idUsuariosEquipo[]" value="${id}">`;
        });
        contSeleccionados.innerHTML = htmlChips;
        contInputs.innerHTML = htmlInputs;
    }

    function renderResultados(lista) {
        if (!lista || lista.length === 0) {
            contResultados.innerHTML = '<p class="sinDatos">No se encontraron operarios.</p>';
            contResultados.classList.remove('oculto');
            return;
        }

        let html = '';
        lista.forEach(function (item) {
            if (operariosSeleccionados[item.idUsuario]) return;
            html += `
                <div class="resultadoOperario" data-id="${item.idUsuario}"
                    data-nombre="${escapeHtml(item.nombreCompletoUsuario)}"
                    data-foto="${escapeHtml(item.fotoUsuario)}">
                    <img src="/public/uploads/usuarios/${encodeURIComponent(item.fotoUsuario || '')}?v=${v}" alt="operario">
                    <div>
                        <p class="nombreResultadoOperario">${escapeHtml(item.nombreCompletoUsuario)}</p>
                        <p class="cargoResultadoOperario">${escapeHtml(item.nombreCargo)}</p>
                    </div>
                </div>
            `;
        });

        contResultados.innerHTML = html !== '' ? html : '<p class="sinDatos">Todos los operarios encontrados ya están en el equipo.</p>';
        contResultados.classList.remove('oculto');
    }

    function buscarOperarios() {
        const filtroNombre = inputFiltro.value;
        const filtroArea = inputFiltroArea ? inputFiltroArea.value : '';
        const url = `/api/personal?filtroNombre=${encodeURIComponent(filtroNombre)}&filtroArea=${encodeURIComponent(filtroArea)}`;

        fetch(url, requestOptions)
            .then(function (response) {
                if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
                return response.json();
            })
            .then(function (result) {
                if (!result || !result.result) {
                    renderResultados([]);
                    return;
                }
                renderResultados(result.result.resultado || []);
            })
            .catch(function (error) {
                console.error('Error al buscar operarios:', error);
            });
    }

    function buscarConDebounce() {
        clearTimeout(timeoutFiltro);
        timeoutFiltro = setTimeout(buscarOperarios, 300);
    }

    inputFiltro.addEventListener('input', buscarConDebounce);
    inputFiltro.addEventListener('focus', buscarOperarios);

    contResultados.addEventListener('click', function (e) {
        const card = e.target.closest('.resultadoOperario');
        if (!card) return;

        const id = card.getAttribute('data-id');
        if (!id || operariosSeleccionados[id]) return;

        if (Object.keys(operariosSeleccionados).length >= 20) {
            if (typeof lanzarAlerta === 'function') lanzarAlerta('No se pueden asignar más de 20 operarios.', 'alerta-roja');
            return;
        }

        operariosSeleccionados[id] = {
            nombre: card.getAttribute('data-nombre'),
            foto: card.getAttribute('data-foto')
        };
        card.remove();
        renderSeleccionados();
    });

    contSeleccionados.addEventListener('click', function (e) {
        const btnQuitar = e.target.closest('.quitarOperarioCrear');
        if (!btnQuitar) return;

        const id = btnQuitar.getAttribute('data-id');
        if (!id) return;

        delete operariosSeleccionados[id];
        renderSeleccionados();
    });

    function limpiar() {
        Object.keys(operariosSeleccionados).forEach(function (id) {
            delete operariosSeleccionados[id];
        });
        inputFiltro.value = '';
        contResultados.innerHTML = '';
        contResultados.classList.add('oculto');
        renderSeleccionados();
    }

    return {
        contar: function () {
            return Object.keys(operariosSeleccionados).length;
        },
        limpiar: limpiar,
        // Precarga el selector con un equipo existente (por ejemplo, al duplicar
        // una orden). Recibe el arreglo equipo del API infoReporte.
        precargar: function (equipo) {
            limpiar();
            (equipo || []).forEach(function (item) {
                const id = Number(item.idUsuario);
                if (!id) return;
                operariosSeleccionados[id] = {
                    nombre: item.nombreCompletoUsuario || '',
                    foto: item.fotoUsuario || ''
                };
            });
            renderSeleccionados();
        }
    };
};
